import { Box, Typography } from "@mui/material";

export default function VerificationEmailSent () {
  return (
    <Box p={1} mt={8}>
      <Typography variant="h6">Confirm Email Address</Typography>
      <Typography variant="body2">
        Please confirm your email address.
      </Typography>
    </Box>
  );
}
